// Shareable monthly summary card (single-page PDF), built with
// @react-pdf/renderer. Replaces the old canvas-painted PNG: same payload and
// same one-call download flow, but the card now comes out of the same
// branded document pipeline as the period reports (./report/ShareCardDocument).
//
// Contract with MonitoringSection.jsx — do not change the signature:
//   downloadShareCard(d) -> downloads a PDF in the browser.
//   d: ShareCardData { monthLabel, kwh, savedRs, co2Kg, percentile, trees }

import { pdf } from "@react-pdf/renderer";
import { registerReportFonts } from "./report/fonts";
import { ShareCardDocument } from "./report/ShareCardDocument";
import { saveBlob } from "./report/saveBlob";

export async function downloadShareCard(d) {
  registerReportFonts();
  const blob = await pdf(<ShareCardDocument data={d} />).toBlob();
  const slug = d.monthLabel.trim().replace(/\s+/g, "-");
  saveBlob(blob, `greentek-solar-${slug}.pdf`);
}
